export class ApiError extends Error {
  public statusCode: number;

  constructor(message: string, statusCode: number = 500) {
    super(message);
    Object.setPrototypeOf(this, ApiError.prototype);
    this.statusCode = statusCode;
  }
}

export class ClientValidationError extends Error {
  constructor(message: string = 'Invalid or missing input.') {
    super(message);
    Object.setPrototypeOf(this, ClientValidationError.prototype);
  }
}
